var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkTo)?_c('b-link',{staticClass:"my-3 mehr-button shadow-sm",attrs:{"to":_vm.linkTo,"router-tag":"b-button"}},[_c('contentPart',{attrs:{"handle":"moreButton"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }